import { render, staticRenderFns } from "./FechasProyectadasDetalle.vue?vue&type=template&id=ebce3098"
import script from "./FechasProyectadasDetalle.vue?vue&type=script&lang=js"
export * from "./FechasProyectadasDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports